import { getSessionReviewAPI } from '../api/sessionReview';
import { getItemWithExpiration } from '../lib/utils';

export const fetchGetSessionReview = (params: { centerId: string; startDate?: string; endDate?: string }) => ({
    queryKey: ['getSessionReviewAPIQuery', params.startDate, params.endDate],
    queryFn: () => {
        const authorization = getItemWithExpiration('authorization');

        return getSessionReviewAPI({
            ...params,
            accessToken: authorization,
        });
    },
    onSuccess: (data: any) => {
        // 데이터 정제 로직
        return data;
    },
});
